import { __exportAll } from "../../../../_virtual/_rolldown/runtime.js";
import { parseFactory } from "../../../../validators/parse.js";
import { z } from "zod";
//#region src/central/v3/schedules/post/validate.ts
var validate_exports = /* @__PURE__ */ __exportAll({
	RequestSchema: () => RequestSchema,
	ResponseSchema: () => ResponseSchema,
	parse: () => parse
});
var PartnerDataSchema = z.object({ facebookPartnerData: z.object({
	crossposts: z.array(z.object({ destinationId: z.string() })).optional(),
	destinationId: z.string().optional(),
	thumbnailUploaded: z.boolean().optional(),
	type: z.string().optional()
}) });
var ContentDestinationScheduleSchema = z.object({
	autoArchive: z.boolean().optional(),
	autoArchivePlaylists: z.array(z.string()).optional(),
	channelId: z.string().optional(),
	description: z.string().optional(),
	durationSeconds: z.number().nullable().optional(),
	id: z.string().nullable().optional(),
	imageUrl: z.string().optional(),
	leadTimeMillis: z.number().optional(),
	mediaId: z.string().nullable().optional(),
	partnerData: PartnerDataSchema.optional(),
	privacy: z.string().optional(),
	publishStatus: z.enum([
		"created",
		"ready",
		"unpublished",
		"published",
		"scheduled_unpublished",
		"scheduled_published",
		"completed"
	]).optional(),
	published: z.boolean().optional(),
	realtimePlayback: z.boolean().optional(),
	rtmpDestinationId: z.string().optional(),
	startTimeOffsetMillis: z.number().optional(),
	title: z.string(),
	type: z.enum([
		"EMBED",
		"FACEBOOK",
		"RSP_SOURCE",
		"SAVEONLY",
		"RTMP",
		"YOUTUBE"
	]),
	webEncoderProfileId: z.string().optional(),
	webEventProfileId: z.string().optional()
});
var EncoderScheduleSchema = z.object({
	durationMillis: z.number(),
	encoderId: z.string(),
	encoderProfileId: z.string().optional(),
	eventProfileId: z.string(),
	localStartTime: z.string(),
	rrule: z.string().optional(),
	title: z.string()
});
var RequestSchema = z.object({
	contentDestinationSchedules: z.array(ContentDestinationScheduleSchema).optional(),
	description: z.string().optional(),
	durationSeconds: z.number().nullable().optional(),
	enabled: z.boolean().optional(),
	encoderSchedule: EncoderScheduleSchema.optional(),
	endDay: z.string().optional(),
	imageUrl: z.string().optional(),
	localStartTime: z.string().optional(),
	rrule: z.string().optional(),
	sourceAlignmentOffsetMillis: z.number().nullable().optional(),
	sourceEventId: z.string().optional(),
	startDay: z.string().optional(),
	startNow: z.boolean().optional(),
	streamType: z.enum([
		"SIMLIVE",
		"LIVE",
		"REPUBLISH",
		"EXISTING_ENCODER_EVENT",
		"EXISTING_MEDIA"
	]),
	syncDetails: z.boolean().optional(),
	timeZone: z.string().optional(),
	title: z.string()
});
var ScheduledPartnerDataSchema = z.object({ facebookPartnerData: z.object({
	crossposts: z.array(z.object({ destinationId: z.string() })),
	destinationId: z.string().optional(),
	thumbnailUploaded: z.boolean().optional(),
	type: z.enum([
		"yt_create_new",
		"fb_timeline",
		"fb_event",
		"fb_page",
		"fb_group",
		"ig_create_new",
		"tt_create_new"
	]).optional()
}) });
var ScheduledContentDestinationSchema = z.object({
	autoArchive: z.boolean(),
	autoArchivePlaylists: z.array(z.string()).optional(),
	channelId: z.string().optional(),
	description: z.string().optional(),
	durationSeconds: z.number().optional(),
	id: z.string(),
	imageUrl: z.string().optional(),
	leadTimeMillis: z.number().optional(),
	mediaId: z.string().optional(),
	partnerData: ScheduledPartnerDataSchema.optional(),
	privacy: z.enum([
		"public",
		"friends_of_friends",
		"all_friends",
		"private",
		"unlisted"
	]).optional(),
	publishStatus: z.enum([
		"created",
		"ready",
		"unpublished",
		"published",
		"scheduled_unpublished",
		"scheduled_published",
		"completed"
	]).optional(),
	published: z.boolean(),
	realtimePlayback: z.boolean(),
	revision: z.number().optional(),
	rtmpDestinationId: z.string().optional(),
	startTimeOffsetMillis: z.number(),
	title: z.string(),
	type: z.enum([
		"EMBED",
		"FACEBOOK",
		"RSP_SOURCE",
		"SAVEONLY",
		"RTMP",
		"YOUTUBE"
	]),
	webEncoderProfileId: z.string().optional(),
	webEventProfileId: z.string().optional(),
	webEventProfileName: z.string().optional()
});
var ScheduledEncoderSchema = z.object({
	durationMillis: z.number(),
	encoderId: z.string(),
	encoderName: z.string().optional(),
	encoderProfileId: z.string().optional(),
	encoderProfileName: z.string().optional(),
	eventProfileId: z.string(),
	eventProfileName: z.string().optional(),
	id: z.string(),
	localStartTime: z.string(),
	rrule: z.string().optional(),
	title: z.string()
});
var ContentScheduleSchema = z.object({
	contentDestinationSchedules: z.array(ScheduledContentDestinationSchema),
	customerId: z.string(),
	description: z.string().optional(),
	durationSeconds: z.number().optional(),
	enabled: z.boolean(),
	encoderSchedule: ScheduledEncoderSchema.optional(),
	endDay: z.string().optional(),
	id: z.string(),
	imageUrl: z.string().optional(),
	localStartTime: z.string(),
	occurrences: z.array(z.object({
		endTime: z.string(),
		startTime: z.string()
	})).optional(),
	origination: z.enum([
		"API",
		"PRO_PRESENTER",
		"MANUAL_START_FROM_ENCODER_EVENT",
		"RSP_EGRESS_CALLBACK",
		"EVENT_UPLOAD_CALLBACK",
		"GO_LIVE"
	]).optional(),
	rrule: z.string().optional(),
	sourceEventId: z.string().optional(),
	startDay: z.string(),
	streamType: z.enum([
		"SIMLIVE",
		"LIVE",
		"REPUBLISH",
		"EXISTING_ENCODER_EVENT",
		"EXISTING_MEDIA"
	]),
	syncDetails: z.boolean(),
	timeZone: z.string(),
	title: z.string()
});
var WebChannelSchema = z.object({
	active: z.string().nullable(),
	av1OutputAllowed: z.boolean(),
	branded: z.boolean().nullable(),
	bucket: z.string().nullable(),
	chromeCastAppId: z.string().nullable(),
	delaySeconds: z.number().nullable(),
	deleteAfter: z.number().nullable(),
	description: z.string().nullable(),
	detectQrCodes: z.boolean(),
	dvrWindowSeconds: z.number().nullable(),
	loadBalPrefix: z.string().nullable(),
	name: z.string().nullable(),
	nextSimLive: z.string().nullable(),
	offlineImageEnabled: z.boolean(),
	offlineImageUrl: z.string().nullable(),
	offlinePlaylistEnabled: z.boolean(),
	offlinePlaylistId: z.string().nullable(),
	offlineVideoEnabled: z.boolean(),
	offlineVideoId: z.string().nullable(),
	persistentUrls: z.object({
		dashUrl: z.string().nullable(),
		dashUrlEnabled: z.boolean().nullable(),
		enabled: z.boolean(),
		hlsUrl: z.string().nullable(),
		hlsUrlEnabled: z.boolean().nullable()
	}).nullable(),
	provisioned: z.boolean(),
	regionId: z.string().nullable(),
	revision: z.number(),
	routingKey: z.string().nullable(),
	social: z.boolean().nullable(),
	subtitlesEnabled: z.boolean(),
	tombstone: z.boolean(),
	type: z.enum([
		"public",
		"return_feed",
		"social"
	]).nullable(),
	uuid: z.string().nullable()
});
var RtmpDestinationSchema = z.object({
	customerId: z.string(),
	id: z.string(),
	name: z.string(),
	rtmpViewUrl: z.string().nullable(),
	streamKey: z.string(),
	streamUrl: z.string()
});
var StartTimeConflictSchema = z.object({
	conflictingStartTime: z.string(),
	contentDestinationScheduleId: z.string(),
	contentScheduleId: z.string(),
	rtmpDestinationId: z.string().nullable(),
	webEventProfileId: z.string().nullable()
});
var ResponseSchema = z.object({
	conflictingRtmpDestinations: z.array(RtmpDestinationSchema),
	conflictingStartTimes: z.array(StartTimeConflictSchema),
	conflictingWebChannels: z.array(WebChannelSchema),
	conflictingWithEncoders: z.array(ContentScheduleSchema),
	conflictingWithRtmpDestinations: z.array(ContentScheduleSchema),
	conflictingWithWebChannels: z.array(ContentScheduleSchema)
});
var parse = parseFactory(ResponseSchema);
//#endregion
export { validate_exports };

//# sourceMappingURL=validate.js.map